"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfile = void 0;
const legacy_models_1 = require("@daytrip/legacy-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const travel_agent_model_1 = require("../../../travel-agent/models/travel-agent.model");
/**
 * We have started moving roles related data from users collection to a separate collections.
 * This model is supposed to be a representation of the user data extended with roles specific data (travel agent, driver, drivers company).
 */
let UserProfile = class UserProfile extends legacy_models_1.User {
    get isCustomer() {
        if (this.driver || this.driversCompany || this.travelAgent) {
            return false;
        }
        // users with roles are internal management users (e.g. CS, DS, etc)
        if (this.userRoles?.roles.length) {
            return false;
        }
        return true;
    }
};
exports.UserProfile = UserProfile;
__decorate([
    (0, type_graphql_1.Field)(() => travel_agent_model_1.TravelAgentModel, { nullable: true }),
    (0, class_transformer_1.Type)(() => travel_agent_model_1.TravelAgentModel),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", travel_agent_model_1.TravelAgentModel)
], UserProfile.prototype, "travelAgent", void 0);
exports.UserProfile = UserProfile = __decorate([
    (0, type_graphql_1.ObjectType)("UserProfile")
], UserProfile);
//# sourceMappingURL=user-profile.js.map